import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

const BOOTSTRAP_KEY = "uh_host_bootstrap_at";
const BOOTSTRAP_MS = 30 * 60 * 1000; // 30 minutes

function hasBootstrapAccess() {
  try {
    const t = Number(localStorage.getItem(BOOTSTRAP_KEY) || 0);
    return t && Date.now() - t < BOOTSTRAP_MS;
  } catch {
    return false;
  }
}

export default function RoleGuard({ mustHaveRole, children }) {
  const { user, roles = [], loading } = useAuth();
  const location = useLocation();
  if (loading) return null;

  const pathname = location.pathname || "";
  const isHostPath = pathname.startsWith("/host");
  const isHostOnboarding = pathname.startsWith("/host/listings/new");
  const bootstrap = hasBootstrapAccess();

  // Not signed in → keep host intent so Account shows the right CTA
  if (!user) {
    const dest = isHostPath ? "/account?becomeHost=1" : "/account";
    return <Navigate to={dest} replace state={{ from: location }} />;
  }

  // Host requirement:
  // - Always allow onboarding route
  // - Allow ALL /host/* routes during bootstrap window
  if (
    mustHaveRole &&
    !roles.includes(mustHaveRole) &&
    !(isHostOnboarding || (isHostPath && bootstrap))
  ) {
    return <Navigate to="/account?becomeHost=1" replace state={{ from: location }} />;
  }

  return children;
}
